'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var pReflect = require('p-reflect');

var pLimit = require('p-limit');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(array) {
    var options,
        _options$concurrency,
        concurrency,
        limit,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _options$concurrency = options.concurrency, concurrency = _options$concurrency === void 0 ? Infinity : _options$concurrency;
            limit = pLimit(concurrency);
            return _context.abrupt("return", Promise.all(array.map(function (element) {
              if (element && typeof element.then === 'function') {
                // eslint-disable-line promise/prefer-await-to-then
                return pReflect(element);
              }

              if (typeof element === 'function') {
                return pReflect(limit(function () {
                  return element();
                }));
              }

              return pReflect(Promise.resolve(element));
            })));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();